module.exports = __webpack_public_path__ + "img/27_69.86bd98dd.png";